<template>
  <div class="tooltip">
    <font-awesome-icon :icon="['fa', 'info-circle']" size="xs" />
    <span class="tooltiptext"><slot></slot></span>
  </div>
</template>

<script>

export default {
  name: 'ToolTip',
  // props: {
  //   text: {
  //     type: String,
  //     default: '',
  //   },
  // },
};

</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip > svg {
  border-bottom: 1px dotted #444444;
  margin: 0 0.15rem;
}

@media screen and (max-width: 414px) {
  .tooltip {
    width: 100%;
  }
}
.tooltip .tooltiptext {
  visibility: hidden;
  height: auto;
  background-color: #e4e4e4;
  color: #444444;
  text-align: left;
  border-radius: 6px;
  padding: 10px;
  position: absolute;
  z-index: 1;
  bottom: 0;
  left: 0;
  right: 0;
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
}

.tooltip:hover {
  width: 70%;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>
